import React from 'react';
import styles from './onboarding.module.css';
import { PhoneNumberInput } from '../PhoneNumberInput';

export default function TextReminderSetup({ phoneNumber, setPhoneNumber, phoneNumberError,
    setPhoneNumberError, eventTime, setEventTime = () => { } }) {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", paddingTop: '2rem', gap: '2rem' }}>
                <h1 className={styles.onboardingGreeting} style={{ marginBottom: "0.5rem", maxWidth: "18rem" }}>
                    Get a reminder each day to stick with it
                </h1>
                <div>
                    <div className={styles.flexDiv}>
                        <label htmlFor="preferred-time">
                            <p className={styles.para} style={{ marginBottom: '0.3rem' }}>Pick a time</p>
                        </label>
                        <input id="preferred-time" type="time" className={styles.timeDropdown}
                            value={eventTime} onChange={(e) => setEventTime(e.target.value)}
                        />
                    </div>
                    <div className={styles.flexDiv} style={{ position: 'relative', textAlign: "center", marginTop: "1.5rem" }}>
                        <label htmlFor="phone-number">
                            <p className={styles.para} style={{ marginBottom: '0.3rem' }}>Enter phone number</p>
                        </label>
                        <PhoneNumberInput
                            phoneNumber={phoneNumber}
                            setPhoneNumber={setPhoneNumber}
                            error={phoneNumberError}
                            setError={setPhoneNumberError}
                        />
                        {phoneNumberError &&
                            <p className={styles.para} style={{ fontSize: "0.8rem", color: 'rgb(196, 70, 70)', position: "absolute", bottom: "-3rem", left: 0, right: 0 }}>
                                Please enter a valid phone number
                            </p>
                        }
                    </div>
                </div>
                <p className={styles.para} style={{ maxWidth: "17rem", marginTop: "1rem" }}>Users with reminders are <span style={{ fontStyle: "italic" }}>2.5x</span> more likely to see results.</p>
            </div>
        </>
    );
}
